import { FileType } from "@prisma/client";
import { privateAxios } from "../axiosInstances";
import {
  PdfTemplateImage,
  PdfTemplateImageRequest,
  SignedUrlInfos,
} from "@ac-expo/api-types";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export const getUploadSignedUrl = async (fileType: FileType) => {
  const { data } = await privateAxios<SignedUrlInfos>({
    url: `/file/upload-signed-url`,
    method: "get",
    params: {
      fileType,
    },
  });

  return data;
};

export const uploadFile = async (file: File, fileType: FileType) => {
  const { signedUrl, key } = await getUploadSignedUrl(fileType);
  await axios.put(signedUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
  });
  return { key, fileName: file.name, fileType };
};

export const getDownloadUrl = async (key: string, fileType: FileType) => {
  const { data } = await privateAxios<{ fileUrl: string }>({
    url: `/file/download-url`,
    method: "get",
    params: {
      key,
      fileType,
    },
  });

  return data.fileUrl;
};

// Reduces a PDF template image on the server; throws when it is refused.
export const shrinkImageForPdfTemplateOnServer = async (src: string) => {
  const { data } = await privateAxios<PdfTemplateImage>({
    url: `/file/pdf-template-image`,
    method: "post",
    data: { src } satisfies PdfTemplateImageRequest,
  });

  return data.dataUrl;
};

export const useUploadFileMutation = () => {
  return useMutation({
    mutationFn: ({ file, fileType }: { file: File; fileType: FileType }) =>
      uploadFile(file, fileType),
  });
};
